import React, { useState } from 'react';
import Dropdown from '../../../../Components/Dropdown';
import TabBar from '../../../../Components/TabBar';
import TabItem from '../../../../Components/TabItem';
import { CategorySelector } from './CategorySelector';
import { CategorySearchProduct } from './CategorySearchProduct';

export default function SecondCategorySelect({
	categoryList,
	handleSelectCategory,
	secondCategorySelected,
	categoryTypeSelected,
	needTenantForSearch,
	searchProductFeed,
	tenanSelected
}) {

	const [searchBy, setSearchBy] = useState('category');
	const [isOpen, setIsOpen] = useState(false);
	const btnClass = ['custom_input', 'clickable', 'w_auto', 'm', 'bg_white'];

	function onSelect(categoryId) {
		handleSelectCategory(categoryId);
		setIsOpen(false);
	}

	return (
		<>
			<Dropdown
				isOpen={isOpen}
				toggle={(s) => setIsOpen(s)}
				scrollbar={false}
				button={
					<button className={btnClass.join(' ')}>
						<span className='custom_input_value has_label'>
							<span className='custom_input_value_label'>Category</span>
							{secondCategorySelected.name}
						</span>
						<span className='custom_input_arrow' />
					</button>
				}
			>
				<div className='flex flex_v dropdown_max_height'>
					<div className='dropdown_section flex_item_fix'>
						<TabBar>
							<TabItem
								message='Search by category'
								selected={searchBy === 'category'}
								onClick={() => setSearchBy('category')}
							/>
							<TabItem
								message='Search by product'
								selected={searchBy === 'product'}
								onClick={() => setSearchBy('product')}
							/>
						</TabBar>
					</div>
					{searchBy === 'category' && (
						<CategorySelector
							categoryList={categoryList}
							handleSelectCategory={onSelect}
						/>
					)}
					{searchBy === 'product' && (
						<CategorySearchProduct
							needTenantForSearch={needTenantForSearch}
							tenanSelected={tenanSelected}
							handleSelectCategory={onSelect}
							searchProductFeed={searchProductFeed}
							categoryTypeSelected={categoryTypeSelected}
						/>
					)}
				</div>
			</Dropdown>
		</>
	);
}